import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export type HubspotChatLoadStatus = 'loading' | 'ready' | 'unavailable';
export const HUBSPOT_PORTAL_ID = '459884';
export const HUBSPOT_SCRIPT_ID = 'hs-script-loader';
export const HUBSPOT_SCRIPT_SRC = `https://js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
const READY_POLL_MS = 250;
const INJECT_AFTER_MS = 1000;
const FAIL_AFTER_MS = 10000;
export const isHubspotChatScriptReady = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const conversations = (window as Window & {
    HubSpotConversations?: {
      widget?: unknown;
    };
  }).HubSpotConversations;
  return !!conversations?.widget;
};
export const ensureHubspotChatScript = () => {
  if (typeof document === 'undefined') {
    return null;
  }
  const existing = document.getElementById(HUBSPOT_SCRIPT_ID) || document.querySelector(`script[src*="js.hs-scripts.com/${HUBSPOT_PORTAL_ID}"]`);
  if (existing instanceof HTMLScriptElement) {
    return existing;
  }
  const script = document.createElement('script');
  script.id = HUBSPOT_SCRIPT_ID;
  script.src = HUBSPOT_SCRIPT_SRC;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
  return script;
};
export const useHubspotChatLoadStatus = () => {
  const $ = _c(2);
  const [status, setStatus] = useState("loading");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (isHubspotChatScriptReady()) {
        setStatus("ready");
        return;
      }
      let cancelled = false;
      let injected = false;
      const startedAt = Date.now();
      const tick = () => {
        if (cancelled) {
          return true;
        }
        if (isHubspotChatScriptReady()) {
          setStatus("ready");
          return true;
        }
        const elapsed = Date.now() - startedAt;
        if (!injected && elapsed >= INJECT_AFTER_MS) {
          injected = true;
          const script = ensureHubspotChatScript();
          script?.addEventListener("error", () => {
            if (!cancelled && !isHubspotChatScriptReady()) {
              setStatus("unavailable");
            }
          });
        }
        if (elapsed >= FAIL_AFTER_MS) {
          setStatus("unavailable");
          return true;
        }
        return false;
      };
      if (tick()) {
        return;
      }
      const intervalId = window.setInterval(() => {
        if (tick()) {
          window.clearInterval(intervalId);
        }
      }, READY_POLL_MS);
      return () => {
        cancelled = true;
        window.clearInterval(intervalId);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return status;
};